import * as yup from 'yup';

export const initialValues = {
  travelNecessity: '',
  daysStay: '',
  locations: '',
  precautions: '',
  customerContact: '',
};

export const validationSchema = yup.object().shape({
  travelNecessity: yup.string().required('Travel necessity is required'),
  daysStay: yup
    .number()
    .typeError('Days of stay must be a number')
    .required('Days of stay is required')
    .positive('Days of stay must be a positive number'),
  locations: yup.string().required('Location is required'),
  precautions: yup.string().required('Precautions are required'),
  customerContact: yup.string().required('Customer contact is required'),
});
